import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const dataStudioImporterSelectors = importerSelectors(
  'dataStudio.importer',
);

export default dataStudioImporterSelectors;
